module.exports = __webpack_public_path__ + "static/media/Logo_telcel.6b3b8530.png";